import { IBidResponse } from '../../typings/IPrebid'
import { IBidRequest } from '../../typings/IPrebidAdapter'
import { Event } from '../eventManager/EventManager'
import WebModel from '../models/WebModel'
import {
  parseBidRequest,
  parseBidResponse,
  parseBidTimeout,
  parseGoogletagEvent
} from './BidParsers'
import { IMetricsClient } from './MetricsTracker'
import './NewRelic/NewRelic.js'

export class MetricsNewRelicClient implements IMetricsClient {
  constructor(readonly model: WebModel, newrelic = window.newrelic) {
    if (!newrelic) {
      return
    }
    // Disables NewRelic error handling so Sentry can do its job better.
    // newrelic.setErrorHandler((err) => true)

    newrelic.setCustomAttribute('windowHeight', window.innerHeight)
    newrelic.setCustomAttribute('windowWidth', window.innerWidth)
  }

  record(event: Event.bidTimeout, data: Array<IBidRequest>): void
  record(event: Event.bidRequested, data: IBidRequest): void
  record(event: Event.bidResponse, data: IBidResponse): void
  // these typings aren't being inflected by the switch statement for some reason =(
  record(event: Event, data: any, newrelic = window.newrelic): void {
    if (this.model.disable_newrelic || !newrelic) {
      return
    }

    switch (event) {
      case Event.bidResponse:
        newrelic.addPageAction(
          'bidResponse',
          parseBidResponse(data, this.model)
        )
        break
      case Event.bidWon:
        newrelic.addPageAction('bidWon', parseBidResponse(data, this.model))
        break
      case Event.bidRequested:
        if (this.model.newRelicBidRequests) {
          newrelic.addPageAction(
            'bidRequested',
            parseBidRequest(data, this.model)
          )
        }
        break
      case Event.bidTimeout:
        data.forEach((bid) => {
          if (bid.auctionId === 'web') {
            newrelic.addPageAction(
              'bidTimeout',
              parseBidTimeout(bid, this.model)
            )
          }
        })
        break
      case Event.impressionViewable:
        newrelic.addPageAction(
          Event.impressionViewable,
          parseGoogletagEvent(data, this.model)
        )
        break
      case Event.slotRenderEnded:
        newrelic.addPageAction(Event.slotRenderEnded, {
          ...parseGoogletagEvent(data, this.model),
          isEmpty: data.isEmpty
        })
        break
      case Event.newRelicLoaded:
        newrelic.addPageAction(Event.newRelicLoaded, data)
        break
      case Event.timeOnSite:
        newrelic.addPageAction(Event.timeOnSite, data)
        break
      default:
    }
  }
}
